export default {
	loading: state => state.loading,
	fetchLoading: state => state.fetchLoading,
	materialsAndSupplies: state => state.materialsAndSupplies,
};
